module.exports = __webpack_public_path__ + "static/media/S13_B.fb631dae.png";